import React from 'react';
import './custom-footer.component.scss';
import { Col, Layout, Row } from "antd";

const { Footer } = Layout;

export const CustomFooter = props => {



  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const c = { ...props.customColors };

  const variant = props.variant;
  const isMobile = variant === 'mobile';
  const rowGutter = isMobile ? { xs: 12, sm: 12 } : { lg: 16, md: 10 };
  const brandColProps = { span: isMobile ? 24 : 10 };
  const companyColProps = { span: isMobile ? 24 : 7 };
  const supportColProps = { span: isMobile ? 24 : 7 };

  return (
    <Footer style={{ background: c.footer_bg_color }}>
      <Row gutter={rowGutter}>
        <Col {...brandColProps}>
              <h3 className="footer-title">{global.operatorName}</h3>
              <section>
                  <h4 className="footer-description">Book Bus Tickets Online</h4>
                  <section>
                    <h6 className="copyright-info"> © {currentYear} All Right Reserved. </h6>
                  </section>
              </section>
        </Col>

        <Col {...companyColProps}>
          <div className="footer-page-links">
            <div className="title">
              <span style={{ overflowWrap: 'anywhere' }}>
              Company
              </span>
            </div>
            <div className="links">
              <ul>
                <li >About Us</li>
                <li >Privacy Policy</li>
                <li >Terms & Conditions</li>
                <li >Refund & Cancellation Policy</li>
              </ul>
            </div>
          </div>
        </Col>

        <Col {...supportColProps}>
          <div className="footer-support-links">
            <div className="title">
              Support
            </div>
            <div className="links">
              <ul>
                <li >Manage Bookings</li>
                <li >Contact Us</li>
              </ul>
            </div>
          </div>
        </Col>

      </Row>
        <Row gutter={rowGutter}>

            <Col {...brandColProps}>

            </Col>

            <Col {...companyColProps}>
                <div className="links">
                    <a href='https://www.qwikbus.in'>Powered by QwikBus</a>
                </div>
            </Col>

            <Col {...supportColProps}>

            </Col>

        </Row>
    </Footer>
  );
};
